/** @jsxImportSource theme-ui */
import { useEffect, useState } from 'react'
import { Box } from 'theme-ui'

export const TextGenerateEffect = ({
  words,
  className,
  filter = true,
  duration = 0.5,
}: {
  words: string
  className?: string
  filter?: boolean
  duration?: number
}) => {
  const [scope, setScope] = useState<HTMLDivElement | null>(null)
  const wordsArray = words.split(' ')

  useEffect(() => {
    if (!scope) return

    const elements = scope.querySelectorAll('.word')
    elements.forEach((element, idx) => {
      const htmlElement = element as HTMLElement
      setTimeout(() => {
        htmlElement.style.filter = filter ? 'blur(0px)' : 'none'
        htmlElement.style.opacity = '1'
      }, idx * 100)
    })
  }, [scope, filter])

  const renderWords = () => {
    return (
      <Box
        ref={setScope}
        sx={{
          display: 'inline-block',
        }}
        className={className}
      >
        {wordsArray.map((word, idx) => {
          return (
            <Box
              key={word + idx}
              className="word"
              sx={{
                display: 'inline-block',
                marginRight: '8px',
                opacity: 0,
                filter: filter ? 'blur(10px)' : 'none',
                transition: `all ${duration}s ease-in-out`,
              }}
            >
              {word}
            </Box>
          )
        })}
      </Box>
    )
  }

  return renderWords()
}
